import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const BG_IMG = "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1600&q=80";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("admin@bildung.de");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const params = new URLSearchParams(loc.search);
  const expired = params.get("expired") === "1";
  const nextUrl = params.get("next");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const from = nextUrl || loc.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#F9FAFB]">
      <div className="relative hidden md:block">
        <img src={BG_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0AA09E]/85 via-[#00CCC9]/70 to-[#0AA09E]/90" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <img
              src="https://www.we-academy.de/assets/logo-BKbEqJ-O.png"
              alt="We Academy"
              className="h-11 w-11 object-contain bg-white rounded-md p-1"
            />
            <div>
              <div className="font-display text-lg font-bold">We Academy</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/85">Finanz</div>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-white/85 mb-3">We finance</div>
            <h1 className="font-display text-4xl lg:text-5xl font-bold leading-[1.05] text-white">
              AVGS, FBW & Zahlungseingang — an einem Ort.
            </h1>
            <p className="mt-4 text-white/90 max-w-md text-sm leading-relaxed">
              Behalten Sie Ihre Liquidität, Ihren Break-even und Ihre Gewinnziele im Blick — visuell, in Echtzeit, präzise.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-sm">
          <div className="md:hidden flex items-center gap-2 mb-8">
            <img
              src="https://www.we-academy.de/assets/logo-BKbEqJ-O.png"
              alt="We Academy"
              className="h-10 w-10 object-contain"
            />
            <div>
              <div className="font-display text-lg font-bold">We Academy</div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#5B6371]">Finanz</div>
            </div>
          </div>
          <div className="label-eyebrow mb-2">Anmeldung</div>
          <h2 className="font-display text-3xl font-semibold text-[#1F242E]">Willkommen zurück</h2>
          <p className="text-sm text-[#5B6371] mt-1.5">Melden Sie sich mit Ihren Zugangsdaten an.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="login-form">
            {expired && (
              <div
                className="text-sm text-[#0AA09E] bg-[#E6F7F7] border border-[#B6E8E7] rounded-md px-3 py-2.5"
                data-testid="login-expired-notice"
              >
                Ihre Sitzung ist abgelaufen. Bitte erneut anmelden.
              </div>
            )}
            <div>
              <label className="block text-xs font-medium text-[#1F242E] mb-1.5">E-Mail</label>
              <input
                type="email"
                required
                className="field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#1F242E] mb-1.5">Passwort</label>
              <input
                type="password"
                required
                className="field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div
                className="text-sm text-[#FF6B5C] bg-[#FFF1EE] border border-[#FFD9D2] rounded-md px-3 py-2"
                data-testid="login-error"
              >
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-[#0AA09E] hover:bg-[#088987] text-white text-sm font-medium rounded-md px-4 py-2.5 transition-colors disabled:opacity-60"
            >
              {loading ? "Anmelden …" : "Anmelden"}
            </button>
          </form>

          <p className="text-xs text-[#5B6371] mt-6">
            Noch kein Konto?{" "}
            <Link to="/register" className="text-[#0AA09E] font-medium hover:underline" data-testid="link-register">
              Jetzt registrieren
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
